import { render } from "./DamagesComponent.vue?vue&type=template&id=1cd032bc&ts=true"
import script from "./DamagesComponent.vue?vue&type=script&lang=ts"
export * from "./DamagesComponent.vue?vue&type=script&lang=ts"

import "./DamagesComponent.vue?vue&type=style&index=0&id=1cd032bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__